import Vue from 'vue';
import {HTTP} from '@/utils/httpCommonUtil';
import {BallPulseLoader} from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner';
import GenericModal from '@/componentsReusable/genericModal.vue';
import {UserRoleEnum} from '@/enums/userRolesEnum';

export default Vue.component('shift-facility-info-card', {
  name: 'ShiftFacilityInfoCard',
  data () {
    let emptyArray: Array<any> = [];
    return {
      cardExpanded: false,
      loadingInitialData: false,
      shiftFacilityInfos: emptyArray,
      showConfirmationModal: false,
      pendingFacilitySpecialty: null
    }
  },
  components: {
    BallPulseLoader,
    VueSimpleSpinner,
    GenericModal
  },
  computed: {
    isProviderUser (): boolean {
      return this.$store.getters['user/hasOnlyRole'](UserRoleEnum.PROVIDER)
    },
    isFacilityUser (): boolean {
      return this.$store.getters['user/hasOnlyRole'](UserRoleEnum.FACILITY_CONTACT)
    }
  },
  created: function () {
    this.expandCard();
  },
  filters: {
    nickname (nickName: string ) {
      if (nickName && nickName.length) {
        return '(' + nickName + ')';
      }
      return '';
    },
    paysMileage (paysMileage: boolean ) {
      return paysMileage ? 'Yes' : 'No';
    }
  },
  methods: {
    expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        this.getShiftFacilityInfo()
      }
    },
    getShiftFacilityInfo () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      HTTP.get('/api/shifts/' + this.$route.params.shiftId + '/shift-facility-info')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Shift Facility Information.");
        }
        let freshShiftFacilityInfos = response.data.data;
        freshShiftFacilityInfos.forEach( function (shiftFacilityInfo: any) {
          shiftFacilityInfo.isViewing = true;
        });

        self.shiftFacilityInfos = freshShiftFacilityInfos;
      })
      .catch(function () {
        console.log('response Error!');
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Shift Facility Info.'
        });
      })
    },
    browseConfirmed (facspec: any) {
      this.showConfirmationModal = false;
      this.browseToFacility(this.pendingFacilitySpecialty, true);
    },
    browseToFacility (facspec: any, bypassBrowseConfirmation: boolean = true) {
      if (!bypassBrowseConfirmation) {
        // Show Browse Confirmation Modal
        this.showConfirmationModal = true;
        this.pendingFacilitySpecialty = facspec;
        return;
      } else {
        this.pendingFacilitySpecialty = null;
      }

      window.open("/facilities/" + facspec.facilityId + "/specialties/" + facspec.specialtyId, '_blank');
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/shift/cards/facilityInfo/ShiftFacilityInfoCard.ts